import * as React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import LoadingButton from '@mui/lab/LoadingButton';
import DownloadLimitExceededPopup from "../../../../Components/DownloadLimit/DownloadLimitExceededPopup";
import {CircularProgress} from "@mui/material";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

class VideoDownloadButton extends React.Component {
  state = {
    limitExceeded: false,
    loading: false,
    downloadStarted: false
  }

  downloadVideo() {
    this.setState({loading: true});

    grecaptcha.ready(function () {
      grecaptcha.execute(recaptchaKey, {action: 'submit'}).then(
        function (token) {
          fetch(`/api/videos/${this.props.videoId}/${this.props.part}/download`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Captcha-Token': token
            },
            body: JSON.stringify(this.details)
          })
            .then(response => {
              if (response.ok) {
                return response.text();
              } else {
                throw new Error(response.status.toString())
              }
            })
            .then(url => {
              this.setState({loading: false, downloadStarted: true, limitExceeded: false});
              window.open("/api/redirect/gdrive?location=" + encodeURIComponent(url) + "&type=video&fileName=" + encodeURIComponent(this.props.fileName), "_blank").focus()
            })
            .catch(reason => {
              if (reason.message === "401") {
                this.setState({limitExceeded: true, loading: false});
              }
            });
        }.bind(this));
    }.bind(this));
  }

  handleClose() {
    this.setState({limitExceeded: false});
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.variant === "icon"
          ?
          (this.state.loading ? <CircularProgress /> : <DownloadForOfflineIcon style={{cursor: "pointer"}} onClick={this.downloadVideo.bind(this)} />)
          :
          <LoadingButton loading={this.state.loading} disabled={this.state.downloadStarted} className={this.props.className} variant="outlined" startIcon={<DownloadIcon/>} onClick={this.downloadVideo.bind(this)}>
            {this.state.downloadStarted ? <React.Fragment>Download Started...</React.Fragment> : <React.Fragment>Download ({this.props.size})</React.Fragment>}
          </LoadingButton>
        }
        <DownloadLimitExceededPopup open={this.state.limitExceeded} action="watch online or download" mediaType="videos" onClose={this.handleClose.bind(this)} />
      </React.Fragment>
    );
  }
}

export default VideoDownloadButton;
